import {get} from 'lodash';

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $auth: {
          get() {
            return get(this, '$store.state.auth');
          },
          set(v) {
            this.$store.commit('auth', v);
          },
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/auth.js